import { GetFeaturesResponse } from "../Models/feature";
import call from "./call";

export const getFeatures = async (): Promise<GetFeaturesResponse> => {
  const response = await call.get("/v1/permission/", {
    snack: {
      error: "features.fetchError",
    },
  });
  return response.data;
};
